import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../App.css"; // Include the provided CSS here.
import TrisulImage from "../images/Mt-Trishul.jpeg";
import EverestImage from "../images/mt_everest.jpg";
import NorthColImage from "../images/everest.jpg";
import OxygenImage from "../images/oxygen1.jpeg";
import MalloryImage from "../images/mallory.jpg";
import AerialSurveyImage from "../images/arial_survey.jpg";
import RecklessClimbImage from "../images/rocklessclimb.jpg";
import SherpaImage from "../images/sherpha.jpeg";

const HistoryCarousel = () => {
  const historyData = [
    {
      year: "1907",
      title: "Trisul Expedition",
      description:
        "Dr. Longstaff led a successful expedition to Trisul, setting a new altitude record of over 7,000 meters.",
      image: TrisulImage,
    },
    {
      year: "1913",
      title: "Captain John Noel's Journey",
      description:
        "Captain Noel disguised himself to explore Tibet and glimpsed the upper portion of Everest. This expedition ignited the British interest in Everest.",
      image: EverestImage,
    },
    {
      year: "1921",
      title: "Survey Expedition Led by Charles Bruce",
      description:
        "Charles Bruce led a survey expedition. George Mallory identified the North Col as a viable climbing route, setting the stage for future expeditions.",
      image: NorthColImage,
    },
    {
      year: "1922",
      title: "First Use of Supplemental Oxygen",
      description:
        "George Finch used supplemental oxygen to reach 8,320 meters, a major milestone. However, the expedition ended tragically with the loss of seven Sherpas in an avalanche.",
      image: OxygenImage,
    },
    {
      year: "1924",
      title: "Mallory and Irvine's Attempt",
      description:
        "George Mallory and Andrew Irvine vanished during their summit attempt, leaving behind a mystery. Mallory's climb, along with Norton's 8,500-meter ascent, added to Everest's allure.",
      image: MalloryImage,
    },
    {
      year: "1933",
      title: "Aerial Survey and New Heights",
      description:
        "An aerial survey by British aircraft provided detailed maps. Climbers reached 8,350 meters in the Rutledge-led expedition, expanding the understanding of Everest's terrain.",
      image: AerialSurveyImage,
    },
    {
      year: "1934",
      title: "Morris Wilson's Reckless Climb",
      description:
        "Morris Wilson embarked on a reckless attempt to summit Everest without mountaineering experience. His ill-planned journey ended in his death, with his diary being discovered in 1935.",
      image: RecklessClimbImage,
    },
    {
      year: "1938",
      title: "Sherpa Tenzing Norgay’s Career Begins",
      description:
        "The British expeditions from 1936 to 1938 failed to summit Everest, but they marked the beginning of Sherpa Tenzing Norgay’s mountaineering career, setting the stage for future success.",
      image: SherpaImage,
    },
  ];

  // State to manage the active slide
  const [activeIndex, setActiveIndex] = useState(0);

  // Handle auto slide change
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) =>
        prevIndex === historyData.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000); // Change slide every 3 seconds

    return () => clearInterval(interval); // Cleanup the interval on component unmount
  }, [historyData.length]); // Add historyData.length to the dependency array

  // Handle click on carousel indicator
  const handleIndicatorClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <section className="history-area mb-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 text-center">
            <h2 className="section-title">
              The Story of the <span>Early Everest Expeditions</span>
            </h2>
            <p className="mb-2">
              During British rule in India, the ambitious British began
              organizing mountaineering expeditions in the Indian Himalayas.
              Unlike earlier expeditions aimed at mapmaking, these expeditions
              sought to establish new records for climbing heights.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div id="history-slid" className="carousel slide" data-ride="carousel">
              <div className="carousel-inner">
                {historyData.map((item, index) => (
                  <div
                    key={item.year}
                    className={`carousel-item row ${index === activeIndex ? "active" : ""}`}
                  >
                    <div className="col-lg-6 col-md-12 pl-0">
                      <div className="history-img">
                        <img
                          className="img-fluid"
                          src={item.image}
                          alt={item.title}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 pr-0">
                      <div className="history-content">
                        <p className="title-bg-small primary-bg">{item.year}</p>
                        <h3 className="column-title">
                          {item.title} <span>{item.year}</span>
                        </h3>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Carousel Indicators (Wrapped inside a div to avoid <p> nesting) */}
              <div className="carousel-indicators-wrapper">
                <ol className="carousel-indicators text-center">
                  {historyData.map((item, index) => (
                    <li
                      key={item.year}
                      className={index === activeIndex ? "active" : ""}
                      onClick={() => handleIndicatorClick(index)}
                    >
                      {item.year}
                    </li>
                  ))}
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HistoryCarousel;
